import { schemes, zSchema } from "@zeal/common";

const browserFileSchema =
  typeof File === "undefined" ? zSchema.any() : zSchema.instanceof(File);

export const postCompanyUBODocumentParamsSchema = zSchema.object({
  companyID: schemes.uuid(),
  ubo_document: browserFileSchema,
  first_name: zSchema.string(),
  last_name: zSchema.string(),
});

export type TPostCompanyUBODocumentParams = zSchema.infer<
  typeof postCompanyUBODocumentParamsSchema
>;

export const postCompanyUBODocumentResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostCompanyUBODocumentResponse = zSchema.infer<
  typeof postCompanyUBODocumentResponseSchema
>;
